module.exports = "/img/caret-left-app.png?104c440f522e7d9116f6a57f82e1b0e1";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/caret-left-app.png
// module id = UERq
// module chunks = 76